import { ServerConfigPage } from './../Yonetim/server-config/server-config';
import { M_REMEMBER_ACC } from './../../models/M_REMEMBER_ACC';
import { BllRememberAcc } from './../../providers/bll/bll-remember-acc';
import { M_USER } from './../../models/M_USER';
import { Ortak } from './../../providers/ortak';
import { M_SERVICE_INFO } from './../../models/M_SERVICE_INFO';
import { BllServisBilgisi } from './../../providers/bll-servis-bilgisi';
import { HomePage } from './../home/home';
import { BllOrtak } from './../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, App, MenuController, ModalController } from 'ionic-angular';
@Component({
  selector: 'page-giris',
  templateUrl: 'giris.html',
})
export class GirisPage {
  Users = [];
  Logins: any;
  sunucuAdresi = "";
  txtkullaniciadi: "";
  txtsifre: any;
  nav: NavController;
  adresler: M_SERVICE_INFO[] = [];
  adres: M_SERVICE_INFO = new M_SERVICE_INFO();
  showServerDropdown: boolean = true;
  girisBilgileriHatirla = false;
  girisSegment = "giris";
  gelenkullanici = [];
  kad: any = {};
  suankitarih;
  kullanicilar: any = { Name: "", Sifre: "" };
  personel: M_USER = new M_USER();
  bllRememberAcc: BllRememberAcc = new BllRememberAcc();
  modelRememberAccounts: M_REMEMBER_ACC[] = [];
  constructor(public navCtrl: NavController,
    public menu: MenuController,
    public ortak: Ortak,
    public modalCtrl:ModalController,
    public bllOrtak: BllOrtak,
    public alert: AlertController,
    public app: App) {
  }

  ionViewDidLoad() {
    this.navCtrl = this.app.getRootNav();
    this.menu.enable(false);
    this.gunkontrol();
  
    this.kullaniciGetir();

  }
  giris(e) {
    if (e.keyCode == 13) {
      this.girisislemi();
    }
  }
  girisislemi() {
    var formData = new FormData();
    formData.append("aranan", this.txtsifre);
    formData.append("kullaniciAdi", this.txtkullaniciadi);
    this.bllOrtak.islem(formData, "Login", "", true).then(a => {
      var sonuc = <any>a;
      this.ortak.storagePersonelEkle(sonuc.SonucObject);
      if (sonuc.Sonuc == 1) {
       
        this.girisBilgileriniHatirlaIslemleri();
        this.navCtrl.setRoot(HomePage);
        this.menu.enable(false);
      }
      if (sonuc.Sonuc != 1) {
        this.showAlert("Hata", "Kullanıcı Bulunamadı");
      }
    })
  
  }
  
  showAlert(tittle: string, subTitle: string) {
    let alert = this.alert.create({
      title: tittle,
      subTitle: subTitle,
      buttons: ['Tamam']
    });
    alert.present();
  }
  gunkontrol() {
    this.bllOrtak.islemWithoutPost("GununTarihi", "", false).then(a => {
      var sonuc = <any>a;
      this.suankitarih = this.ortak.tarih(sonuc.SonucObject, "ll");
      this.ortak.storageGunTarihiEkle(sonuc.SonucObject);
    })
  }
 
  kullaniciGetir() {
    var bllRememberAcc = new BllRememberAcc();
    bllRememberAcc.getAll().then(b => {
      var sonuc = <any>b;
      this.kullanicilar = b[0].Sifre;
      if (this.kullanicilar.length > 1)
      this.kullanicilar = b[0].Sifre;
          this.txtkullaniciadi = sonuc[0].Sifre;
          this.txtsifre = sonuc[0].Name;
          this.girisBilgileriHatirla = true;
        
     
    }).catch(x => {
     
    })
  }
  girisBilgileriniHatirlaIslemleri() {
    this.bllRememberAcc.deleteAll2().then(a => {
      if (this.girisBilgileriHatirla == true) {
        var remAcc = new M_REMEMBER_ACC();
        remAcc.Sifre = this.txtkullaniciadi;
        remAcc.Name = this.txtsifre;
        this.bllRememberAcc.addOrUpdate(remAcc).then(b => {
        })
      }
    })
  }
  SunucuAyarlari()
  {
    let modal = this.modalCtrl.create(ServerConfigPage);
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    });
    modal.present();
  
  }
}



// WEBPACK FOOTER //
// ./src/pages/giris/giris.ts